import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgProgress, NgProgressRef } from '@ngx-progressbar/core';
import { ToastrService } from 'ngx-toastr';
import { CustomerGroupModel } from '../../../modules/customerUser/model/customer-group.model';
import { AuthService } from '../../../modules/security/service/auth.service';
import {
  UserAuth0GroupsModel,
  UserClaimModel
} from '../../../modules/user/model/user-auth0groups-model';
import {
  ClaimModel,
  GroupModel,
  UserModel
} from '../../../modules/user/model/user.model';
import { UsersService } from '../../../modules/user/service/users.service';

@Component({
  selector: 'vixxo-permission',
  templateUrl:
    'console/app-js/app/components/vixxolink-permissions/vixxolink-permissions.component.html'
})
export class VixxolinkPermissionComponent implements OnInit {
  @Input() opened: boolean;
  @Output() closed = new EventEmitter<any>();
  groupId = [];

  constructor(
    private authService: AuthService,
    private usersService: UsersService,
    protected progressService: NgProgress,
    protected toastr: ToastrService
  ) {}

  public loadingIndicator: boolean = false;
  public email: string = '';
  public validEmail: boolean = false;
  public roleDisabled: boolean = true;
  public error: string;
  public isCustomerProfile: boolean = false;
  public isServiceProviderProfile: boolean = false;
  public isResetDefaultProfile: boolean = false;
  public isCustomerQuoteViewer: boolean = false;
  public isCustomerInvoiceViewer: boolean = false;
  public isCustomerQuoteApprover: boolean = false;
  public isCorporateUser: boolean = false;
  public isReportViewer: boolean = false;
  public isCustomerPriorityEditor: boolean = false;
  public isFinancial: boolean = false;
  public isUserManagementAdministrator: boolean = false;
  public isMobileTechnician: boolean = false;
  public isController: boolean = false;
  public isInteralServiceProvider: boolean = false;
  public isCustomerQuoteViewerAdded: boolean = false;
  public isCustomerInvoiceViewerAdded: boolean = false;
  public isCustomerQuoteApproverAdded: boolean = false;
  public isReportViewerAdded: boolean = false;
  public isCustomerPriorityEditorAdded = false;
  public customerNumbers: string;
  public customerNumbersDisplay: string;
  public customerGroupName: string;
  public customerSiteIds: string[];
  public customerSiteIdsDisplay: string;
  public customerTierIds: number[];
  public customerTierIdsDisplay: string;
  public searchedUserMetadata: any;
  public allUserGroups: GroupModel[];
  public serviceProviderNumbers: string[];
  public loggedInUser: any;
  public serviceProviderAccess: string;
  protected progressRef: NgProgressRef;

  ngOnInit() {
    this.loadingIndicator = true;
    this.getLoggedInUserInfo();
  }
  getLoggedInUserInfo() {
    let userInfo = this.authService.getUserInfo();
    this.usersService
      .getUserInfoByEmail(userInfo.email)
      .subscribe((loggedInUserInfo: any) => {
        this.loggedInUser = loggedInUserInfo;
        this.finishProgress();
      });
  }
  public close(): void {
    this.opened = false;
    this.closed.emit(this.opened);
  }

  /**
   * Checks if email is a valid email
   * @param email string
   */
  public checkValidEmail(): void {
    this.isCustomerProfile = this.isServiceProviderProfile = false;
    this.customerNumbersDisplay = this.customerSiteIdsDisplay = null;
    this.customerSiteIds = this.customerTierIds = [];
    this.customerNumbers = '';

    let emailRegex = new RegExp(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
    if (emailRegex.test(this.email)) {
      this.validEmail = true;
    } else {
      this.validEmail = false;
      this.error = 'Please provide a valid email.';
    }
  }

  /**
   * Validates the Email exists in Auth0
   * @param email: string
   */
  public validateAuth0EmailExists(): void {
    this.loadingIndicator = true;
    this.usersService
      .validateEmailExists(this.email.toLowerCase())
      .subscribe((res: any) => {
        if (res.success && res.validateEmail) {
          this.viewPermissions();
        } else {
          this.validEmail = false;
          this.loadingIndicator = false;
          this.isCustomerProfile = false;
          this.isServiceProviderProfile = false;
          this.error = 'This email id does not exist in the system.';
        }
      });
  }

  disableApplyButton(): boolean {
    if (this.isCustomerProfile) {
      return !this.isCustomerProfile;
    } else if (this.isServiceProviderProfile) {
      return !this.isServiceProviderProfile;
    }
    return true;
  }

  public viewPermissions(): void {
    this.usersService
      .getUserInfoByEmail(this.email)
      .subscribe((metadata: any) => {
        this.searchedUserMetadata = metadata;
        if (
          metadata.serviceProviderNumbers &&
          metadata.serviceProviderNumbers.length
        ) {
          this.assignServiceProviderMetadata(metadata);
        } else if (metadata.customerNumbers) {
          this.usersService
            .getCustomerGroupCustomers(metadata.customerNumbers[0])
            .subscribe((group: CustomerGroupModel[]) => {
              this.customerGroupName =
                group && group.length ? group[0].customerGroupName : '';
              if (metadata.claims) {
                metadata.claims.forEach((claim: ClaimModel) => {
                  if (
                    claim.claimType ===
                      UserClaimModel.CLAIM_SITE_TIER_LEVEL_ACCESS &&
                    claim.claimValue != ''
                  ) {
                    this.customerTierIds = claim.claimValue
                      .split(',')
                      .map(Number);
                  }
                  if (
                    claim.claimType ===
                      UserClaimModel.CLAIM_INDIVIDUAL_SITE_ACCESS &&
                    claim.claimValue != ''
                  ) {
                    this.customerSiteIds = claim.claimValue
                      .split(',')
                      .map(String);
                  }
                });
              }

              this.customerNumbers = metadata.customerNumbers;
              this.customerNumbersDisplay = metadata.customerNumbers
                .toString()
                .replace(/,/g, ', ');

              this.customerSiteIds = this.customerSiteIds
                ? this.customerSiteIds
                : [];
              this.customerSiteIdsDisplay = this.customerSiteIds
                .toString()
                .replace(/,/g, ', ');
              this.isCustomerProfile = true;
              this.customerTierIds = this.customerTierIds
                ? this.customerTierIds
                : [];
              this.customerTierIdsDisplay = this.customerTierIds
                .toString()
                .replace(/,/g, ', ');
              this.customerRoleInformation(metadata);
              this.loadingIndicator = false;
            });
        } else {
          this.loadingIndicator = false;
        }
      });
  }

  public customerRoleInformation(metadata: any): void {
    if (metadata.claims && metadata.claims.length > 0) {
      let corporateAccess = metadata.claims.find(
        (claim: any) =>
          claim.claimType === UserClaimModel.CLAIM_CORPORATE_ACCESS
      );
      if (
        corporateAccess &&
        corporateAccess.claimValue &&
        corporateAccess.claimValue != ''
      ) {
        this.isCorporateUser = true;
      }
    }
    if (metadata.groups && metadata.groups.length > 0) {
      metadata.groups.forEach((group: any) => {
        if (
          group.name.toLowerCase() ===
          UserAuth0GroupsModel.CUSTOMER_QUOTE_VIEWER_GROUP.toLowerCase()
        ) {
          this.isCustomerQuoteViewer = this.isCustomerQuoteViewerAdded = true;
        }
        if (
          group.name.toLowerCase() ===
          UserAuth0GroupsModel.CUSTOMER_QUOTE_APPROVER_GROUP.toLowerCase()
        ) {
          this.isCustomerQuoteApprover = this.isCustomerQuoteApproverAdded = true;
        }

        if (
          group.name.toLowerCase() ===
          UserAuth0GroupsModel.CUSTOMER_INVOICE_VIEWER_GROUP.toLowerCase()
        ) {
          this.isCustomerInvoiceViewer = this.isCustomerInvoiceViewerAdded = true;
        }

        if (
          group.name.toLowerCase() ===
          UserAuth0GroupsModel.REPORT_VIEWER_GROUP.toLowerCase()
        ) {
          this.isReportViewer = this.isReportViewerAdded = true;
        }
        if (
          group.name.toLowerCase() ===
          UserAuth0GroupsModel.CUSTOMER_PRIORITY_EDITOR_GROUP.toLowerCase()
        ) {
          this.isCustomerPriorityEditor = this.isCustomerPriorityEditorAdded = true;
        }
      });
    }
  }

  applyToMyProfile() {
    this.loadingIndicator = true;
    let user = {};

    if (this.isCustomerProfile) {
      let claims = this.searchedUserMetadata.claims;
      const customerApprovalLimitIndex = claims.findIndex(
        (claim: ClaimModel) =>
          claim.claimType == UserClaimModel.CLAIM_QUOTE_APPROVAL_LIMIT
      );
      if (customerApprovalLimitIndex > -1) {
        claims[customerApprovalLimitIndex].claimValue = '';
      }

      let customerUser = {
        id: this.loggedInUser.id,
        email: this.loggedInUser.email,
        firstName: this.loggedInUser.firstName,
        lastName: this.loggedInUser.lastName,
        customerNumbers: this.customerNumbers,
        siteIds: this.customerSiteIds ? this.customerSiteIds : [],
        siteTiers: this.customerTierIds ? this.customerTierIds.map(String) : [],
        claims: claims
      };
      user = customerUser;
    } else if (this.isServiceProviderProfile) {
      let serviceProviderUser = {
        id: this.loggedInUser.id,
        email: this.loggedInUser.email,
        firstName: this.loggedInUser.firstName,
        lastName: this.loggedInUser.lastName,
        serviceProviderNumbers: this.serviceProviderNumbers
      };
      user = serviceProviderUser;
    }

    let newGroups = this.addGroups(user);
    let removeGroups = this.removeGroups(this.loggedInUser);
    this.modifyGroupsUpdateProfile(newGroups, removeGroups, user);
  }

  resetProfile() {
    this.loadingIndicator = true;
    this.isResetDefaultProfile = true;
    this.isServiceProviderProfile = false;
    this.isCustomerProfile = false;
    let user = {
      id: this.loggedInUser.id,
      email: this.loggedInUser.email,
      firstName: this.loggedInUser.firstName,
      lastName: this.loggedInUser.lastName,
      claims: []
    };

    this.usersService.getGroups().subscribe((results: any) => {
      this.allUserGroups = results.groups;
      let groupsRest = [];
      this.allUserGroups.forEach((groupInfo: GroupModel) => {
        if (groupInfo.name === UserAuth0GroupsModel.SERVICECENTER_GROUP) {
          groupsRest.push(groupInfo);
        }
        if (groupInfo.name === UserAuth0GroupsModel.SUPPORT_USER_GROUP) {
          groupsRest.push(groupInfo);
        }
        if (
          groupInfo.name === UserAuth0GroupsModel.USER_MANAGEMENT_ADMINISTRATOR
        ) {
          groupsRest.push(groupInfo);
        }
        if (groupInfo.name === UserAuth0GroupsModel.SPM_USER_MANAGER) {
          groupsRest.push(groupInfo);
        }
        if (groupInfo.name === UserAuth0GroupsModel.CUSTOMER_USER_MANAGER) {
          groupsRest.push(groupInfo);
        }
      });

      let removeGroups = this.removeGroups(this.loggedInUser);
      this.modifyGroupsUpdateProfile(groupsRest, removeGroups, user);
    });
  }

  removeGroups(loggedInUser): GroupModel[] {
    let groups: GroupModel[] = [];
    loggedInUser.groups.forEach(group => {
      let isSupportOrUserAdminGroup =
        group.name.toLowerCase() ===
          UserAuth0GroupsModel.SUPPORT_USER_GROUP.toLowerCase() ||
        group.name.toLowerCase() ===
          UserAuth0GroupsModel.USER_MANAGEMENT_ADMINISTRATOR.toLowerCase() ||
        group.name.toLowerCase() ===
          UserAuth0GroupsModel.ADMIN_PORTAL_GROUP.toLowerCase();
      if (!isSupportOrUserAdminGroup) {
        groups = [...groups, group];
      }
    });
    return groups;
  }

  addGroups(user): GroupModel[] {
    user.groups = [];
    if (this.isCustomerProfile) {
      user.groups = this.searchedUserMetadata.groups;

      if (this.isCustomerQuoteApprover) {
        let customerFilteredGroups = user.groups.filter(
          group =>
            group.name.toLowerCase() !==
            UserAuth0GroupsModel.CUSTOMER_QUOTE_APPROVER_GROUP.toLowerCase()
        );
        user.groups = customerFilteredGroups;
      }
    } else if (this.isServiceProviderProfile) {
      user.groups = this.searchedUserMetadata.groups;
    }

    return user.groups;
  }

  private modifyGroupsUpdateProfile(
    newGroups: Array<any>,
    removedGroups: Array<any>,
    user: any
  ): void {
    this.loadingIndicator = true;
    if (removedGroups.length > 0) {
      this.usersService
        .deleteGroups(removedGroups.map(item => item.id), user.id)
        .subscribe((resultsDelete: boolean) => {
          if (resultsDelete) {
            this.onAPISuccess('User Groups have been removed successfully');
            this.addGroupsUpdateProfile(newGroups, user);
          } else {
            this.onAPIError('An error occurred while removing User Groups');
            this.loadingIndicator = false;
            this.close();
          }
        });
    } else {
      this.addGroupsUpdateProfile(newGroups, user);
    }
  }

  addItemId(newGroups: Array<any>) {
    if (newGroups.length > 0) {
      let groups = [];
      groups.push(...newGroups);
      this.groupId = groups.map(item => item.id);
    }
  }

  private addGroupsUpdateProfile(newGroups: Array<any>, user: UserModel): void {
    this.loadingIndicator = true;
    this.addItemId(newGroups);
    if (newGroups.length > 0) {
      this.usersService
        .addGroups(this.groupId, user.id)
        .subscribe((resultsAdd: boolean) => {
          if (resultsAdd) {
            this.onAPISuccess('User Groups have been assigned successfully');
            this.updateUserProfile(user);
          } else {
            this.onAPIError('An error occurred while adding User Groups');
            this.loadingIndicator = false;
            this.close();
          }
        });
    } else {
      this.updateUserProfile(user);
    }
  }

  private updateUserProfile(user: any): void {
    this.loadingIndicator = true;
    if (this.isCustomerProfile) {
      this.usersService
        .updateCustomerUser(user)
        .subscribe((resultsUpdate: boolean) => {
          if (resultsUpdate) {
            this.onAPISuccess('User has been successfully updated');
          } else {
            this.onAPIError('An error occurred while updating user');
          }
          this.loadingIndicator = false;
          this.close();
        });
    } else if (this.isServiceProviderProfile) {
      this.usersService
        .updateServiceProvider(user)
        .subscribe((resultsUpdate: boolean) => {
          if (resultsUpdate) {
            this.onAPISuccess('User has been successfully updated');
          } else {
            this.onAPIError('An error occurred while updating user');
          }
          this.loadingIndicator = false;
          this.close();
        });
    } else if (this.isResetDefaultProfile) {
      this.usersService
        .updateServiceCenter(user)
        .subscribe((resultsUpdate: boolean) => {
          if (resultsUpdate) {
            this.onAPISuccess('User has been successfully updated');
          } else {
            this.onAPIError('An error occurred while updating user');
          }
          this.loadingIndicator = false;
          this.close();
        });
    }
  }

  private assignServiceProviderMetadata(metadata: any): void {
    this.isServiceProviderProfile = true;
    this.isMobileTechnician = metadata.groups.find(
      (group: any) =>
        group.name.toLowerCase() ===
        UserAuth0GroupsModel.SERVICEPROVIDER_MOBILE_GROUP.toLowerCase()
    );
    this.isController = metadata.groups.find(
      (group: any) =>
        group.name.toLowerCase() ===
        UserAuth0GroupsModel.SERVICEPROVIDER_CONTROLLER_GROUP.toLowerCase()
    );
    this.isUserManagementAdministrator = metadata.groups.find(
      (group: any) =>
        group.name.toLowerCase() ===
        UserAuth0GroupsModel.USER_MANAGEMENT_ADMINISTRATOR.toLowerCase()
    );
    this.isFinancial = metadata.groups.find(
      (group: any) =>
        group.name.toLowerCase() ===
        UserAuth0GroupsModel.SERVICEPROVIDER_FINANCIAL_GROUP.toLowerCase()
    );
    this.isInteralServiceProvider = metadata.groups.find(
      (group: any) =>
        group.name.toLowerCase() ===
        UserAuth0GroupsModel.INTERNAL_SERVICEPROVIDER_GROUP.toLowerCase()
    );
    this.isReportViewer = metadata.groups.find(
      (group: any) =>
        group.name.toLowerCase() ===
        UserAuth0GroupsModel.REPORT_VIEWER_GROUP.toLowerCase()
    );

    this.serviceProviderNumbers = metadata.serviceProviderNumbers;
    this.serviceProviderAccess = this.serviceProviderNumbers.join(', ');

    this.loadingIndicator = false;
  }

  /**
   * Completes any pending progress and shows successfull message to the User
   * @param message
   * @param title
   */
  protected onAPISuccess(message): void {
    this.finishProgress();
    this.toastr.success(message);
  }

  protected onAPIError(message): void {
    this.finishProgress();
    this.toastr.error(message);
    this.loadingIndicator = false;
  }

  protected finishProgress(): void {
    this.loadingIndicator = false;
  }
}
